module.exports = __webpack_public_path__ + "static/media/logo.b9276150.svg";